<!--@format-->
<template>
    <div
        :class="[
            { 'dropdown-shown': currentStep.title === 'Company Exists' },
            'add-company-widget',
        ]"
    >
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>{{ currentStep.title }}</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <div v-if="currentStep.title === 'Website'" class="step website-step">
                    <div class="company-form-row">
                        <app-input
                            :data-locator="getDataLocator('website-input')"
                            :label="'Enter Website'"
                            type="text"
                            :placeholder="'www.google.com'"
                            v-model="company.website"
                        />
                        <strong class="red-accent" v-if="hasWebsiteError">
                            {{ websiteErrorMessage }}
                        </strong>
                    </div>
                </div>
                <div v-else-if="currentStep.title === 'Company'" class="step">
                    <div v-if="company.website" class="message-wrapper">
                        <div>
                            We've scoured the internet! This is what information we could find.
                        </div>
                        <div>Please double-check as the internet can be strange and imperfect.</div>
                    </div>
                    <div class="company-form-row company-profile-image">
                        <image-upload
                            id="company-image-upload"
                            :uploadUrl="uploadUrl"
                            :placeholderImage="placeholderImage"
                            :providedImageUrl="company.logoUrl"
                            @fileUploadSuccess="updateImageUrl"
                            orientation="horizontal"
                        >
                        </image-upload>
                    </div>
                    <div class="company-form-row">
                        <div class="company-details-container">
                            <label class="company-details-title">Company Details</label>
                            <div class="company-details-row">
                                <label> Mark as account</label>
                                <app-switch
                                    :data-locator="getDataLocator('mark-account-switch')"
                                    :value="company.isAccount"
                                    size="large"
                                    @input="toggleMarkAsAccount"
                                />
                            </div>
                            <p>Companies designated as an account are those under contract.</p>
                        </div>
                    </div>
                    <div class="company-form-row">
                        <div class="input-container">
                            <app-input v-model="company.name" :label="'Company Name'" :data-locator="getDataLocator('company-name-input')"/>
                        </div>
                        <div class="input-container">
                            <label>Company Type</label>

                            <company-types-dropdown v-model="company.type" :clientId="clientId" :data-locator="getDataLocator('company-type-dropdown')" />
                        </div>
                    </div>
                    <div class="company-form-row">
                        <div class="input-container">
                            <app-input v-model="company.website" :label="'Website'" :data-locator="getDataLocator('website-input')" />
                        </div>
                        <div class="input-container">
                            <app-input v-model="company.email" :label="'Email'" :data-locator="getDataLocator('email-input')" />
                        </div>
                    </div>
                    <div class="company-form-row">
                        <div class="input-container">
                            <app-input v-model="company.address" :label="'Address'" :data-locator="getDataLocator('address-input')" />
                        </div>
                        <div class="input-container">
                            <app-input v-model="company.address2" :label="'Address 2'" :data-locator="getDataLocator('address-2-input')" />
                        </div>
                    </div>
                    <div class="company-form-row">
                        <div class="input-container">
                            <app-input v-model="company.city" :label="'City'" :data-locator="getDataLocator('city-input')" />
                        </div>
                        <div class="input-container">
                            <app-input v-model="company.state" :label="'State'" :data-locator="getDataLocator('state-input')" />
                        </div>
                    </div>
                    <div class="company-form-row">
                        <div class="input-container">
                            <app-input v-model="company.zipcode" :label="'ZIP code'" :data-locator="getDataLocator('zip-code-input')" />
                        </div>
                        <div class="input-container">
                            <app-input v-model="company.phone" :label="'Phone'" :data-locator="getDataLocator('phone-input')" />
                        </div>
                    </div>
                </div>
                <div
                    v-else-if="currentStep.title === 'Scrubbing' || 'Saving'"
                    class="step scrubbing-step"
                >
                    <quick-add-company-svg />
                </div>
            </div>
            <transition name="slide-down">
                <div v-if="currentStep.title === 'Company Exists'" class="step company-exists-step">
                    <div class="company-exists-container">
                        <div class="company">
                            <h1>Company Already Exists</h1>
                            <div
                                class="company-image"
                                :style="{
                                    'background-image': `url('${
                                        company.logoUrl ||
                                        require('@/assets/images/company-avatar.png')
                                    }')`,
                                }"
                            ></div>
                            <h3>{{ `${company.name ? company.name : ''}` }}</h3>
                            <div class="button-container">
                                <app-button @click="goToCompany" class="white-btn">
                                    Go To Company
                                </app-button>
                                <app-button @click="goToWebsiteStep" class="transparent-btn">
                                    Try Again
                                </app-button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="transparent-btn" @click="closeWidget"> Cancel </app-button>
                </div>
                <div class="action-container">
                    <app-button
                        class="transparent-btn"
                        v-if="currentStep.title === 'Website'"
                        @click="goToCompanyStep"
                    >
                        No Website?
                    </app-button>
                    <app-button
                        v-if="currentStep.title !== 'Website'"
                        class="transparent-btn"
                        @click="goToWebsiteStep"
                    >
                            <back-icon class="back-arrow" color="#18aeff" />
                        Go Back
                    </app-button>
                    <app-button
                        class="colored-btn"
                        :loading="currentStep.loading"
                        @click="currentStep.action"
                    >
                        {{ currentStep.buttonText }}
                        <next-icon class="forward-arrow" color="var(--color-text-inverse)" />
                    </app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const AppInput = () => import('@/components/common/app-input');
const AppSwitch = () => import('@/components/common/app-switch.vue');
const BackIcon = () => import('@/components/svg/grid/l6-back-svg.vue');
const NextIcon = () => import('@/components/svg/grid/m6-next-svg.vue');
const CompanyTypesDropdown = () => import('@/components/company/company-types-dropdown');
const ImageUpload = () => import('@/components/common/image-upload');
const QuickAddScrubbingSvg = () => import('@/components/svg/quick-add/quick-add-scrubbing-svg');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');

import Multiselect from 'vue-multiselect';
import EventBus from '@/scripts/event-bus.js';
import { QaMixin } from '@/mixins/qa-mixin';

export default {
    name: 'quick-add-company-widget',

    components: {
        'app-button': AppButton,
        'app-input': AppInput,
        'app-switch': AppSwitch,
        'back-icon': BackIcon,
        'next-icon': NextIcon,
        'quick-add-company-svg': QuickAddScrubbingSvg,
        multiselect: Multiselect,
        'image-upload': ImageUpload,
        'widget-close-svg': WidgetCloseSvg,
        'company-types-dropdown': CompanyTypesDropdown,
    },

    mixins: [QaMixin],

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            placeholderImage: require('@/assets/images/company-avatar.png'),
            uploadUrl: '/api/Files',
            hasWebsiteError: false,
            websiteErrorMessage: 'Please provide a URL.',

            company: {
                id: null,
                email: null,
                name: null,
                phone: null,
                address: null,
                address2: null,
                zipcode: null,
                city: null,
                state: null,
                logoUrl: null,
                website: null,
                domain: null,
                type: null,
                isAccount: false,
            },

            currentStep: null,

            steps: {
                website: {
                    title: 'Website',
                    buttonText: 'Next Step',
                    loading: false,
                    action: this.scrubCompany,
                },
                scrubbing: {
                    title: 'Scrubbing',
                    buttonText: 'Scrubbing',
                    loading: true,
                    action: null,
                },
                companyExists: {
                    title: 'Company Exists',
                    buttonText: '',
                    action: null,
                    loading: false,
                },
                company: {
                    title: 'Company',
                    buttonText: 'Save',
                    loading: false,
                    action: this.saveCompany,
                },
                saving: { title: 'Saving', buttonText: 'Saving', loading: true },
            },
        };
    },

    computed: {
        clientId() {
            return this.$store.state.context.client.id;
        },

        routeBaseUrl() {
            return this.$store.getters.routeBaseUrl;
        },
    },

    methods: {
        scrubCompany() {
            if (this.company.website === null) {
                this.hasWebsiteError = true;
            } else {
                this.currentStep = this.steps['scrubbing'];

                var domain = this.$helpers.getDomainFromUrl(this.company.website);

                var query = `/api/Clients/${this.clientId}/Companies/Search?website=${this.company.website}`;

                this.$api
                    .get(query)
                    .then((response) => {
                        this.hasWebsiteError = false;

                        if (response.data[0]) {
                            this.populateCompanyFields(response.data[0]);
                            this.goToStep('companyExists');
                        } else {
                            this.hasWebsiteError = false;
                            this.company.domain = domain;

                            var query = `/api/Companies/Scrub?domain=${domain}&clientId=${this.clientId}`;

                            this.$api
                                .get(query)
                                .then((response) => {
                                    if (response.data.length > 0) {
                                        this.populateCompanyFields(response.data[0]);
                                    }

                                    this.goToStep('company');
                                })
                                .catch(() => {
                                    this.createScrubErrorNotification();
                                });
                        }
                    })
                    .catch(() => {
                        this.createComanyErrorNotification();
                    });
            }
        },

        saveCompany() {
            this.currentStep = this.steps['saving'];

            var request = {
                clientId: this.clientId,
                name: this.company.name,
                logoUrl: this.company.logoUrl,
                phone: this.company.phone,
                address: this.company.address,
                address2: this.company.address2,
                region: this.company.state,
                email: this.company.email,
                website: this.company.website,
                domain: this.company.domain,
                zipcode: this.company.zipcode,
                city: this.company.city,
                companyTypeId: this.company.type ? this.company.type.id : null,
                isAccount: this.company.isAccount,
            };

            this.$api
                .post(`/api/Companies/`, request)
                .then((response) => {
                    this.company.id = response.data.Id;
                    this.createCompanySuccessNotification();
                    this.notifyCompanyCreate();
                    this.closeWidget();
                })
                .catch(() => {
                    this.createCompanyFailedNotification();
                    this.closeWidget();
                });
        },

        clearCompany() {
            this.company = {
                id: null,
                email: null,
                name: null,
                phone: null,
                address: null,
                address2: null,
                zipcode: null,
                state: null,
                city: null,
                logoUrl: null,
                website: null,
                domain: null,
                type: null,
                isAccount: false,
            };
        },

        updateImageUrl(imageUrl) {
            this.company.logoUrl = imageUrl;
        },

        closeWidget() {
            EventBus.$emit('close-widget');
        },

        goToStep(step) {
            this.currentStep = this.steps[step];
        },

        goToWebsiteStep() {
            this.currentStep = this.steps['website'];
            this.clearCompany();
        },

        goToCompanyStep() {
            this.currentStep = this.steps['company'];
        },

        goToCompany() {
            this.closeWidget();
            this.$router.push(`/Companies/${this.company.id}`);
        },

        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        populateCompanyFields(response) {
            this.company.id = response.Id;
            this.company.email = response.Email;
            this.company.name = response.Name;
            this.company.phone = response.Phone;
            this.company.address = response.Address;
            this.company.address2 = response.Address2;
            this.company.zipcode = response.ZipCode;
            this.company.state = response.Region;
            this.company.city = response.City;
            this.company.logoUrl = response.LogoUrl;
            this.company.website = response.Website;
        },

        createScrubErrorNotification() {
            var notification = {
                iconUrl: this.placeholderImage,
                subIcon: 'warning',
                message: 'An error occurred during the scrubbing process.',
                actionLabel: null,
                action: () => {},
            };

            EventBus.$emit('show-notification', notification);
        },

        createComanyErrorNotification() {
            var notification = {
                iconUrl: this.placeholderImage,
                subIcon: 'warning',
                message: 'An error occurred looking for your company.',
                actionLabel: null,
                action: () => {},
            };

            EventBus.$emit('show-notification', notification);
        },

        createCompanySuccessNotification() {
            var notification = {
                iconUrl: this.company.logoUrl || this.placeholderImage,
                subIcon: 'success',
                message: '<strong class="blue-accent">Company successfully created!</strong>',
                actionLabel: 'See Company',
                action: () => {
                    this.goToCompany();
                    EventBus.$emit('close-notification', this.notification);
                },
            };

            EventBus.$emit('show-notification', notification);
        },

        notifyCompanyCreate() {
            EventBus.$emit('company:update', this.company);
        },

        createCompanyFailedNotification() {
            var notification = {
                iconUrl: this.company.logoUrl || this.placeholderImage,
                subIcon: 'warning',
                message: 'Company creation failed.',
                actionLabel: null,
                action: () => {},
            };

            EventBus.$emit('show-notification', notification);
        },

        toggleMarkAsAccount() {
            this.company.isAccount = !this.company.isAccount;
        },
    },

    created() {
        this.goToStep('website');
    },
};
</script>

<style scoped>
.add-company-widget .step {
    width: 100%;
}

.add-company-widget .step .message-wrapper {
    text-align: center;
    margin-bottom: 25px;
}

.add-company-widget .step .company-form-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.add-company-widget .step .company-form-row.company-profile-image {
    align-items: center;
    margin: 0 auto 25px auto;
}

.add-company-widget .step .company-form-row.company-profile-image .file-input {
    display: none;
}

.add-company-widget .step .company-form-row.company-profile-image .profile-image {
    width: 84px;
    height: 84px;
    border-radius: 50%;
    margin-right: 35px;
}

.add-company-widget .step .company-form-row .company-details-container {
    display: flex;
    flex-direction: column;
    flex: 1;
    border: 1px solid #cac6cb;
    border-radius: 15px;
    position: relative;
    padding: 20px;
    margin-bottom: 16px;
}
.add-company-widget .step .company-form-row .company-details-container .company-details-title {
    position: absolute;
    top: -16px;
    align-self: center;
    background: white;
    color: #382153;
    padding: 6px 24px;
}

.add-company-widget .step .company-form-row .company-details-container .company-details-row {
    display: flex;
    flex-direction: row;
    align-items: center;
}

.add-company-widget .step .company-form-row .company-details-container .company-details-row label {
    min-inline-size: fit-content;
    margin: 0px;
    margin-right: 22px;
}

.add-company-widget .step .company-form-row .company-details-container p {
    margin: 0px;
}

.add-company-widget .step .company-form-row .input-container {
    display: flex;
    flex-direction: column;
    width: 45%;
    margin-bottom: 24px;
}

.add-company-widget .step .company-form-row .input-container label {
    display: block;
    font: 500 16px/1em 'Roboto';
    margin-bottom: 7px;
}

.add-company-widget .step .company-form-row input[type='text'],
.add-company-widget .step .company-form-row input[type='email'],
.add-company-widget .step .company-form-row input[type='tel'] {
    height: 25px;
    padding: 0px 0px 5px 9px;
    color: #382153;
    border: none;
    border-bottom: 2px solid #e9e9ef;
    outline: none;
}

.add-company-widget .step .company-form-row input[type='text']::placeholder,
.add-company-widget .step .company-form-row input[type='email']::placeholder,
.add-company-widget .step .company-form-row input[type='tel']::placeholder {
    font-size: 16px;
    line-height: 19px;
    color: #cac6cb;
}

.add-company-widget .step .company-form-row input[type='text']:hover,
.add-company-widget .step .company-form-row input[type='email']:hover,
.add-company-widget .step .company-form-row input[type='tel']:hover {
    border-color: #877d88;
}

.add-company-widget .step .company-form-row input[type='text']:focus,
.add-company-widget .step .company-form-row input[type='email']:focus,
.add-company-widget .step .company-form-row input[type='tel']:focus {
    border-bottom: 3px solid #18aeff;
}

.add-company-widget .step.scrub-step .company-form-row {
    flex-direction: column;
}

.add-company-widget .step.scrubbing-step svg {
    width: 100%;
}

.add-company-widget .action-container {
    display: flex;
}

.add-company-widget .action-container .btn {
    margin-left: 15px;
}

.add-company-widget .action-container .btn.colored-btn {
    padding-inline: 50px;
}
.add-company-widget .action-container .btn.colored-btn .forward-arrow {
    margin-left: 8px;
    height: 14px;  
}

.add-company-widget .cancel-container .btn.transparent-btn {
    background: transparent;
    color: #382153;
    border: 1px solid #cac6cb;
}

.add-company-widget .cancel-container .btn.transparent-btn:hover {
    background: #e1e0e5;
}

.add-company-widget .action-container .btn.transparent-btn {
    background: transparent;
    color: #18aeff;
    border: 1px solid #18aeff;
}
.add-company-widget .action-container .btn.transparent-btn .back-arrow {
    margin-right: 16px;
    height: 14px;
}

.add-company-widget .action-container .btn.transparent-btn:hover {
    background: #dbedfa;
}

.add-company-widget .website-step .company-form-row,
.add-company-widget .website-step .company-form-row label {
    display: block;
}

.add-company-widget .website-step .company-form-row input {
    width: 100%;
}

/* COMPANY EXISTS */

.add-company-widget .step.company-exists-step {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    height: 100%;
    width: 100%;
    background: rgb(122, 91, 255);
    background: linear-gradient(0deg, rgba(122, 91, 255, 1) 0%, rgba(227, 141, 238, 1) 100%);
}

.add-company-widget .step.company-exists-step.slide-down-enter-active,
.step.company-exists-step.slide-down-leave-active {
    transition: all 0.3s ease 0s;
}

.add-company-widget .step.company-exists-step.slide-down-enter,
.step.company-exists-step.slide-down-leave-to {
    top: -100%;
}

.add-company-widget .step.company-exists-step .company-exists-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
}

.add-company-widget .step.company-exists-step .company-exists-container .company {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.add-company-widget .step.company-exists-step .company-exists-container .company h1 {
    color: #ffffff;
    margin-bottom: 53px;
}

.add-company-widget .step.company-exists-step .company-exists-container .company-image {
    height: 131px;
    width: 131px;
    border-radius: 50%;
    background-size: cover;
    background-position: 50%;
    margin-bottom: 10px;
}

.add-company-widget .step.company-exists-step .company-exists-container .company h3 {
    color: #ffffff;
    margin-bottom: 32px;
    font-family: 'Roboto', sans-serif;
    font-weight: 600;
}

.add-company-widget .step.company-exists-step .company-exists-container .company .button-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.add-company-widget
    .step.company-exists-step
    .company-exists-container
    .company
    .button-container
    .btn {
    margin-bottom: 15px;
}

.add-company-widget
    .step.company-exists-step
    .company-exists-container
    .company
    .button-container
    .btn.white-btn {
    background: #ffffff;
    color: #8360fe;
    border: none;
}

.add-company-widget
    .step.company-exists-step
    .company-exists-container
    .company
    .button-container
    .btn.white-btn:hover {
    background: #382153;
    color: #ffffff;
    border: none;
}

.add-company-widget
    .step.company-exists-step
    .company-exists-container
    .company
    .button-container
    .btn.transparent-btn {
    background: transparent;
    color: #ffffff;
    width: 100%;
}

.add-company-widget
    .step.company-exists-step
    .company-exists-container
    .company
    .button-container
    .btn.transparent-btn:hover {
    background: #18aeff;
}
</style>
